import React from "react";
import LabelValue from "../../shared/custom/labelValue/LabelValue";
import { useDateCustom } from "../../shared/custom_use/useDateCustom";
import { useLanguageForShared } from "../../shared/utils/languages/useLanguageForShared";

export function VoxiSudFooterRead({ data, validUntil }: any) {
  const { t } = useLanguageForShared();
  const { data: dataFormatter } = useDateCustom();

  const resolvedValidUntil = validUntil || data?.validUntil;

  const tipoPrescrizioneLabel = data?.tipoPrescrizione
    ? t(`voxiSud.tipoPrescrizione.${data.tipoPrescrizione}`)
    : "-";

  return (
    <div className={"row row-gap-4"}>
      <div className="col-sm-12 col-md-4">
        <LabelValue
          label={t("prescription.template.validUntil")}
          value={resolvedValidUntil ? dataFormatter.dateFormatGGmmmYY(resolvedValidUntil) : "-"}
        />
      </div>
      <div className="col-sm-12 col-md-4">
        <LabelValue
          label={t("voxiSud.dataProssimoControllo")}
          value={data?.dataProssimoControllo ? dataFormatter.dateFormatGGmmmYY(data.dataProssimoControllo) : "-"}
        />
      </div>
      <div className="col-sm-12 col-md-4">
        <LabelValue
          label={t("voxiSud.tipoPrescrizione.label")}
          value={tipoPrescrizioneLabel}
        />
      </div>
    </div>
  );
}
